
import { Component, Prop, Vue } from 'vue-property-decorator'

import { EnrollmentForm } from '../types/enrollmentForm'

@Component({ name: 'StepValidation' })
export default class extends Vue {
  @Prop({ required: true }) form!: EnrollmentForm

  get entityKindLabel(): string {
    if (this.form.entityKind === 'Autre') return this.form.entityKindOther || this.form.entityKind
    return this.form.entityKind
  }

  get invoiceModeLabel(): string {
    return this.form.invoiceMode === 'monthly'
      ? this.$t('enrollment.fields.invoiceMonthly') as string
      : this.$t('enrollment.fields.invoicePerOrder') as string
  }

  get deliveryRecap(): string {
    const count = this.form.deliveryAddresses.length + this.form.physicalDeliveryAddresses.length
    if (count > 0) return this.$t('enrollment.validation.deliveryCount', { count }) as string
    if (this.form.wantsPhysicalCards) return this.$t('enrollment.validation.deliveryLater') as string
    return this.$t('enrollment.validation.deliveryNone') as string
  }
}
